import React from 'react';
import PropTypes from 'prop-types';
import defaultStyles from 'commonStyles/components/coupon/_loyalty';
import styleOverrides from 'styles/components/coupon/_loyalty';
import useStyleOverrides from 'common/components/hooks/use-style-overrides';
import WarningIcon from 'common/icons/loyalty/warning';
import AlertIcon from 'common/icons/loyalty/alert';

const AlertBox = (props) => {
  const styles = useStyleOverrides(defaultStyles, styleOverrides);

  return (
    <div className={`${styles.alertBoxWrapper} ${props.warning ? styles.warning : ''}`} role="alert">
      <div className={styles.alertBoxTextWrapper}>
        <div className={styles.alertBoxContainer}>
          {props.warning ?
            <WarningIcon className={styles.alertIconLoyalty} /> :
            <AlertIcon className={styles.alertIconLoyalty} />
          }
          <div className={styles.alertBoxTextWrapper}>
            <div className={styles.alertBoxTitle}>{props.title}</div>
            <span className={styles.alertBoxDescription}>
              {props.description}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

AlertBox.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string.isRequired,
  warning: PropTypes.bool,
};

AlertBox.defaultProps = {
  warning: false,
};

export default AlertBox;
